import { BaseEntity } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";
import { AccountEntityRaw } from "../interface";
import { accountEntityRaw } from "../schema";

export class AccountEntity extends BaseEntity<AccountEntityRaw> {
  private static validation = JsonSchemaValidator.compile(accountEntityRaw);

  constructor(value: AccountEntityRaw) {
    super(JsonSchemaValidator.assert(AccountEntity.validation, value));
  }
}
